var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4.481,
    height: 7.765,
    viewBox: "0 0 4.481 7.765",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(4.481 7.765) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M.431,0,4.28.425a.634.634,0,0,1,.534.541.375.375,0,0,1-.428.436L.537.98A.634.634,0,0,1,0,.439.375.375,0,0,1,.431,0Z",
    transform: "translate(0.958 0) rotate(43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M.537.425,4.385,0a.375.375,0,0,1,.428.436h0A.634.634,0,0,1,4.28.98L.431,1.4A.375.375,0,0,1,0,.967H0A.634.634,0,0,1,.537.425Z",
    transform: "translate(0 6.737) rotate(-43)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0LjQ4MSIgaGVpZ2h0PSI3Ljc2NSIgdmlld0JveD0iMCAwIDQuNDgxIDcuNzY1Ij4KICA8ZyBpZD0iYXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuNDgxIDcuNzY1KSByb3RhdGUoMTgwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF81MyIgZGF0YS1uYW1lPSJQYXRoIDUzIiBkPSJNLjQzMSwwLDQuMjguNDI1YS42MzQuNjM0LDAsMCwxLC41MzQuNTQxLjM3NS4zNzUsMCwwLDEtLjQyOC40MzZMLjUzNy45OEEuNjM0LjYzNCwwLDAsMSwwLC40MzkuMzc1LjM3NSwwLDAsMSwuNDMxLDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjk1OCAwKSByb3RhdGUoNDMpIi8+CiAgICA8cGF0aCBpZD0iUGF0aF81MiIgZGF0YS1uYW1lPSJQYXRoIDUyIiBkPSJNLjUzNy40MjUsNC4zODUsMGEuMzc1LjM3NSwwLDAsMSwuNDI4LjQzNmgwQS42MzQuNjM0LDAsMCwxLDQuMjguOThMLjQzMSwxLjRBLjM3NS4zNzUsMCwwLDEsMCwuOTY3SDBBLjYzNC42MzQsMCwwLDEsLjUzNy40MjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDYuNzM3KSByb3RhdGUoLTQzKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };